import React from 'react'
import BannerImage from './BannerImage'
import Press from './Press'
import WeMakeItEasy from './WeMakeItEasy'
import WatchToLearnMore from './WatchToLearnMore'
import WhyUs from './WhyUs'
import ScrollToTopOnMount from '../ScrollToTopOnMount'
import Loadable from 'react-loadable'
import LoadingComponent from '../LoadingComponent'

const Reviews = Loadable({
  loader: () => import('./Reviews'),
  loading() {
    return null
  }
})
const CurrentServiceLocations = Loadable({
  loader: () => import('./CurrentServiceLocations'),
  loading() {
    return null
  }
})
const OurPartners = Loadable({
  loader: () => import('./OurPartners'),
  loading() {
    return null
  }
})
const BecomePartner = Loadable({
  loader: () => import('./BecomePartner'),
  loading() {
    return null
  }
})
const BookWithUs = Loadable({
  loader: () => import('./BookWithUs'),
  loading() {
    return null
  }
})

const Home = () => (
  <div>
    <ScrollToTopOnMount />
    <BannerImage />
    <Press />
    <WeMakeItEasy />
    <WatchToLearnMore />
    <WhyUs />
    <Reviews />
    <CurrentServiceLocations />
    <OurPartners />
    <BecomePartner />
    <BookWithUs />
  </div>
)

export default Home



// WEBPACK FOOTER //
// ./src/components/home/index.js